import { FC, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import useFeature from '@/contexts/FeatureFlags/useFeature';
import useFeatureFlags from '@/contexts/FeatureFlags/useFeatureFlags';

interface RequireFeatureRouteProps {
  feature: string;
  /** A second flag that opens the route as well - for a screen that two rollouts share. */
  orFeature?: string;
  children: ReactElement;
  /** Where to send users who don't have the feature. Defaults to the fund root. */
  redirectTo?: string;
}

/**
 * Route guard: renders the route only when the feature is enabled for the current
 * fund + user; otherwise redirects. Prevents access by typing the URL directly.
 */
const RequireFeatureRoute: FC<RequireFeatureRouteProps> = ({ feature, orFeature, children, redirectTo = '..' }) => {
  const enabled = useFeature(feature);
  const alsoEnabled = useFeature(orFeature ?? '');
  const { isLoading } = useFeatureFlags();

  if (isLoading) return null; // avoid a redirect flash while the map is loading
  return enabled || alsoEnabled ? children : <Navigate to={redirectTo} replace />;
};

export default RequireFeatureRoute;
